import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import appConfig from '../../../config/config';
import {
    Card, CardBody,
    CardTitle, Form, Row, FormGroup, Button, Col, Input
} from 'reactstrap';
import { renderInput, renderTextArea, renderDatePicker, renderDropdown, renderMultiselect, renderCheckbox } 
from "../../common/renderinput";
import { withRouter } from "react-router";

import { connect } from 'react-redux';
import axios from 'axios';

const q = [
    {valueField: 1, textField:"Title"},
    {valueField: 2, textField:"Appraisal"},
    {valueField: 3, textField:"AVM"},
    {valueField: 4, textField:"Flood/BPO"},
    {valueField: 5, textField:"Evaluation"},
    {valueField: 6, textField:"PCR Property Inspection Condition Report"}
];

class SearchProductForm extends Component {
    constructor(props) {
        super(props);
    }

    handleSearch = (values) => {
        //Use axios to send request
        this.props.loading(true);
        axios.post(
            appConfig.apiGateway.searchUrl,
            JSON.stringify({...values, "Action":"ALLPRODUCT", "User" : this.props.session.session.user.email}, null, 2),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then(response => {
            this.props.loading(false);
            console.log(response.data);
            //this.props.SetData([]);
            this.props.SetData(JSON.parse(response.data.body));
        }, error => {
            this.props.loading(false);
        });

        //Set loading to parent
        //if success loading false, set data
        //if error loading false display banner
    }

    render() {
        return (
            <>
                <Card className="w-100">
                    <CardBody>
                        <CardTitle>Search Criteria</CardTitle>
                        <form onSubmit={this.props.handleSubmit(this.handleSearch)}>
                            <Row form>
                                <Col md={2}>
                                    <FormGroup>
                                        <Field name="searchOrderParam" component={renderInput} label="ID" />
                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Field name="searchLoanParam" component={renderInput} label="Name" />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Field name="ProductGroup" component={renderDropdown} label="Product Group" data={q} textField="textField" valueField="valueField" isLabel={false} />
                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Button color="primary" >Search</Button>
                                        <Button className="ml-3" >Reset</Button>
                                        <Button className="ml-3"  type="button" onClick={() => this.props.Add(true)}>Add</Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                </Card>
            </>
        );
    }
}

const validate = (formvalues) => {
}
const mapStatetoProps = state => {
    return { session: state.session }
}
var sf = reduxForm({
    form: 'searchProductform',
    validate
})(SearchProductForm);
sf = connect(mapStatetoProps)(sf);
export default sf;